<template>
  <base-button
    v-style="{ w: s, h: s }"
    :aria-label="paused ? $t.videoPlay : $t.videoPause"
    :class="brandClasses.control.button"
  >
    <svg aria-hidden="true" class="full" viewBox="0 0 100 100">
      <circle
        :class="[
          brandClasses.control.circle,
          !active && brandClasses.control.circleInactive,
        ]"
        cx="50"
        cy="50"
        fill="none"
        r="45"
        stroke="white"
        stroke-opacity="0.16"
        stroke-width="5"
      />
      <!-- Circular Progress Foreground -->
      <circle
        v-if="active"
        class="transition-all"
        cx="50"
        cy="50"
        fill="none"
        r="45"
        stroke="white"
        stroke-width="5"
        :style="{
          strokeDasharray: circumference,
          strokeDashoffset: offset,
          transform: 'rotate(-90deg)',
          transformOrigin: 'center',
        }"
      />
    </svg>
    <span class="absolute flex center rounded-full">
      <vf-icon
        v-if="active"
        :class="brandClasses.control.icon"
        :name="paused ? 'play' : 'pause'"
        :size
      />
      <span v-else class="text-sm">
        {{ inactiveLabel }}
      </span>
    </span>
  </base-button>
</template>

<script setup lang="ts">
import type { Responsive } from '#types/common'
import type { IconSizes } from '#types/sizes'

const { active = true, progress = 0, inactiveLabel = '', size } = defineProps<{
  inactiveLabel?: string
  paused?: boolean
  active?: boolean // When we have multiple controls, like inside a carousel, we should present the play/pause only on the active video control
  progress?: number
  size?: IconSizes | Partial<Responsive<IconSizes>>
}>()

const { brandClasses } = useAppConfig().components.vf.video || {}

const config = {
  xs: '2.5rem',
  sm: '2.75rem',
  md: '3rem',
  lg: '3.25rem',
}

const circumference = Math.PI * 90
const offset = computed(() => circumference - progress * circumference)

const s = computed(() =>
  mapObject(isObject(size) ? size : { sm: size }, (br) => `${config[br!]}`)
)
</script>
